import { merge } from './helpers/merge';

const defaults = {
  /**
   * API configuration.
   */
  api: {
    callback: '__google_maps_api_provider__',
    channel: 'store-locator',
    client: null,
    key: 'AIzaSyD46GdXdlYmhBFvH5E7bo03tFBY6Gc9PAw',
    language: null,
    // @see https://developers.google.com/maps/documentation/javascript/libraries
    libraries: [
      // 'geometry',
      'places',
    ],
    region: null,
    version: '3.18',
  },

  debug: false,

  dependencies: {
    markerclusterer:
      'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/markerclusterer.js',
    //'snazzy-info-window': 'https://cdn.jsdelivr.net/npm/snazzy-info-window@1.1.1/dist/snazzy-info-window.min.js',
  },

  /**
   * Map configuration.
   */
  map: {
    // Set to false to deactivate clusters
    // @see https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/markerclusterer.js
    clusters: false,
    /*clusters: {
            imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
            ignoreHidden: true,
            maxZoom: 10,
            styles: null,
        },*/

    geocode: false,

    // Set to false to deactivate location marker and circle
    location: false,
    /*location: {
            // Set to false to deactivate location circle
            circle: {
                fillColor: '#213B87',
                fillOpacity: 0.35,
                radius: 5000,
                strokeColor: '#213B87',
                strokeOpacity: 0.8,
                strokeWeight: 2,
            },
            // Set to false to deactivate location marker
            icon: 'https://www.google.com/mapfiles/marker_green.png',
        },*/

    // Default stores markers
    markers: {
      // String or Object
      icon: {
        active: '../content/themes/stem/dist/img/marker-active.svg',
        inactive: '../content/themes/stem/dist/img/marker-inactive.svg',
      },
    },

    // @see https://developers.google.com/maps/documentation/javascript/tutorial
    options: {
      center: {
        lat: 50.6740609,
        lng: 4.470022,
      },
      fullscreenControl: false,
      gestureHandling: 'cooperative',
      mapTypeControl: false,
      mapTypeControlOptions: false,
      scrollwheel: false,
      streetViewControl: false,
      styles: null,
      zoom: 11,
    },
  },

  /**
   * Search configuration.
   * Set to false to deactivate search.
   * If "autocomplete" is set to false, the simple search feature will be used.
   */
  search: {
    // Set to false to deactivate autocomplete
    // @see https://developers.google.com/maps/documentation/javascript/places-autocomplete
    autocomplete: false,
    /*autocomplete: {
            componentRestrictions: {
                country: 'BE',
            },
        },*/

    select: [
      { value: 'afrique', label: 'Afrique' },
      { value: 'amerique-du-Nord', label: 'Amérique du Nord' },
      { value: 'amerique-du-Sud', label: 'Amérique du Sud' },
      { value: 'asie', label: 'Asie' },
      { value: 'europe', label: 'Europe' },
    ],
    text: false,

    // Keys where the search will be performed (default: all)
    keys: ['cat'],
    live: true,
    placeholder: 'Address, postal code or city',
  },

  /**
   * Stores.
   * If String, will be used to get stores via AJAX GET.
   */
  stores: [],

  /**
   * Templates.
   */
  templates: {
    // vue template
    card: `<a class="card--projet mb-4" :href="store.link" @click.prevent>
                <figure>
                    <img :src="store.img" :alt="store.title">
                    <span v-html="store.cat"></span>
                </figure>
                <h2 class="card--projet--title" v-html="store.title"></h2>
                <ul class="list-inline">
                    <li class="list-inline-item">{{store.lieu}}</li>
                    <li class="list-inline-item">{{store.logements}}</li>
                </ul>
            </a>`,
    // simple template with {{name}}
    infoWindow: `<a class="card--projet" href="{{link}}">
                <figure>
                    <img src="{{img}}" alt="{{title}}">
                    <span>{{cat}}</span>
                </figure>
                <h2 class="card--projet--title">{{title}}</h2>
                <ul class="list-inline">
                    <li class="list-inline-item">{{lieu}}</li>
                    <li class="list-inline-item">{{logements}}</li>
                </ul>
            </a>`,
  },

  /**
   * Type.
   */
  type: 'google-map', // @TODO - 'openstreet-map' integration
};

if (window.__features && window.__features['store-locator']) {
  merge(defaults, window.__features['store-locator']);
}

export default defaults;
